import { IRetryPolicy, RetryContext } from "@microsoft/signalr";

/** Custom retry policy for SignalR that is used when the connection is lost. */
class SignalRCustomRetryPolicy implements IRetryPolicy {
    public nextRetryDelayInMilliseconds(retryContext: RetryContext): number {
        const { previousRetryCount } = retryContext;
        const maxDelay = 120000;
        const baseDelay = 2000; // initial delay in milliseconds

        // Calculate delay linearly with a maximum of 2 minutes
        const delay = Math.min(baseDelay + (previousRetryCount * baseDelay), maxDelay);
        return delay;
    }
}

export { SignalRCustomRetryPolicy };
